module.exports = __webpack_public_path__ + "img/team-2.ddd702f.webp";